var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedalBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 114,
    viewBox: "0 0 300 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H288C294.627 0 300 5.37258 300 12V114H0V12Z",
    fill: "url(#paint0_linear_1065_1234)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H288C294.351 0.500003 299.5 5.64873 299.5 12V113.5H0.5V12L0.514648 11.4082C0.822652 5.33195 5.8472 0.5 12 0.5Z",
    stroke: "black",
    strokeOpacity: 0.12
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1065_1234",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 300,
    height: 114
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H288C294.627 0 300 5.37258 300 12V114H0V12Z",
    fill: "url(#paint1_linear_1065_1234)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H288C294.351 0.500003 299.5 5.64873 299.5 12V113.5H0.5V12L0.514648 11.4082C0.822652 5.33195 5.8472 0.5 12 0.5Z",
    stroke: "black",
    strokeOpacity: 0.12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1065_1234)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 91.0469,
    y: 38.4062,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 91.0469 38.4062)",
    stroke: "url(#paint2_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.0469,
    y: 0.40624,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 91.0469 0.40624)",
    stroke: "url(#paint3_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.0469,
    y: 76.6655,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 91.0469 76.6655)",
    stroke: "url(#paint4_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 38.4062,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 129 38.4062)",
    stroke: "url(#paint5_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129,
    y: 0.40624,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 129 0.40624)",
    stroke: "url(#paint6_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.008,
    y: 76.6655,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 129.008 76.6655)",
    stroke: "url(#paint7_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.953,
    y: 38.4062,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 166.953 38.4062)",
    stroke: "url(#paint8_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.953,
    y: 0.40624,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 166.953 0.40624)",
    stroke: "url(#paint9_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.961,
    y: 76.6655,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 166.961 76.6655)",
    stroke: "url(#paint10_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.047,
    y: 38.4062,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 205.047 38.4062)",
    stroke: "url(#paint11_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.047,
    y: 0.40624,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 205.047 0.40624)",
    stroke: "url(#paint12_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.047,
    y: 76.6655,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 205.047 76.6655)",
    stroke: "url(#paint13_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 38.4062,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 243 38.4062)",
    stroke: "url(#paint14_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243,
    y: 0.40624,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 243 0.40624)",
    stroke: "url(#paint15_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.008,
    y: 76.6655,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 243.008 76.6655)",
    stroke: "url(#paint16_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.953,
    y: 38.4062,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 280.953 38.4062)",
    stroke: "url(#paint17_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.953,
    y: 0.40624,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 280.953 0.40624)",
    stroke: "url(#paint18_linear_1065_1234)",
    strokeWidth: 0.574511
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.961,
    y: 76.6655,
    width: 26.3576,
    height: 26.3576,
    transform: "rotate(45 280.961 76.6655)",
    stroke: "url(#paint19_linear_1065_1234)",
    strokeWidth: 0.574511
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M236.972 56.5C236.972 74.4492 233.854 89 230.008 89H244.71C248.557 89 251.674 74.4492 251.674 56.5C251.674 38.5508 248.557 24 244.71 24H230.008C233.854 24 236.972 38.5508 236.972 56.5Z",
    fill: "url(#paint20_linear_1065_1234)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M236.972 56.5C236.972 65.497 236.188 73.6383 234.922 79.523H249.624C250.89 73.6383 251.674 65.497 251.674 56.5C251.674 56.0439 251.663 55.6002 251.659 55.1479H236.957C236.961 55.6002 236.972 56.0439 236.972 56.5Z",
    fill: "url(#paint21_linear_1065_1234)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M273.937 36.1875H217.063C214.819 36.1875 213 38.0064 213 40.25V72.75C213 74.9936 214.819 76.8125 217.063 76.8125H273.937C276.181 76.8125 278 74.9936 278 72.75V40.25C278 38.0064 276.181 36.1875 273.937 36.1875Z",
    fill: "url(#paint22_linear_1065_1234)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1065_1234",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 225,
    y: 25,
    width: 23,
    height: 66
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M247.417 25.6274H232.714C229.385 25.6274 226.607 36.5339 225.918 51.1015L233.115 55.5767L240.639 50.7467C241.357 36.3589 244.115 25.6274 247.417 25.6274ZM240.475 60.1972L233.115 64.8625L225.773 60.2427C226.009 77.2012 229.022 90.628 232.715 90.628H247.417C243.72 90.6275 240.704 77.1768 240.475 60.1972Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1065_1234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.93 36.188H217.055C214.811 36.188 212.992 38.0069 212.992 40.2505V72.7505C212.992 74.9941 214.811 76.813 217.055 76.813H273.93C276.173 76.813 277.992 74.9941 277.992 72.7505V40.2505C277.992 38.0069 276.173 36.188 273.93 36.188Z",
    fill: "url(#paint23_linear_1065_1234)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M260.829 68.6441V72.7499H256.937V68.9355C254.251 68.8386 251.662 68.0992 250.164 67.2618L251.351 62.5915C253.025 63.5064 255.38 64.3433 257.968 64.3433C260.226 64.3433 261.821 63.429 261.821 61.8717C261.821 60.3729 260.517 59.4 257.559 58.4077C253.298 56.9869 250.398 54.9822 250.398 51.1293C250.398 47.5679 252.87 44.8238 257.132 44.0259V40.2505H261.023V43.7534C263.709 43.8314 265.5 44.4343 266.843 45.0767L265.655 49.572C264.663 49.0856 262.775 48.1713 259.915 48.1713C257.326 48.1713 256.49 49.3391 256.49 50.4479C256.49 51.7132 257.89 52.5886 261.277 53.8344C266.045 55.5082 267.913 57.6878 267.913 61.3267C267.912 64.8687 265.461 67.8457 260.829 68.6441Z",
    fill: "url(#paint24_linear_1065_1234)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M244.713 24H230.011C226.682 24 223.903 34.9065 223.214 49.474L230.412 53.9493L237.936 49.1193C238.654 34.7315 241.412 24 244.713 24ZM237.772 58.5697L230.412 63.2351L223.07 58.6152C223.305 75.5737 226.318 89.0006 230.012 89.0006H244.714C241.017 89 238.001 75.5493 237.772 58.5697Z",
    fill: "url(#paint25_linear_1065_1234)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1065_1234",
    x1: 0,
    y1: 57,
    x2: 300,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B9E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1065_1234",
    x1: 150,
    y1: 0,
    x2: 150,
    y2: 114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1065_1234",
    x1: 104.513,
    y1: 38,
    x2: 104.513,
    y2: 64.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1065_1234",
    x1: 104.513,
    y1: 0,
    x2: 104.513,
    y2: 26.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1065_1234",
    x1: 104.513,
    y1: 76.2593,
    x2: 104.513,
    y2: 103.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1065_1234",
    x1: 142.466,
    y1: 38,
    x2: 142.466,
    y2: 64.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1065_1234",
    x1: 142.466,
    y1: 0,
    x2: 142.466,
    y2: 26.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1065_1234",
    x1: 142.474,
    y1: 76.2593,
    x2: 142.474,
    y2: 103.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1065_1234",
    x1: 180.419,
    y1: 38,
    x2: 180.419,
    y2: 64.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1065_1234",
    x1: 180.419,
    y1: 0,
    x2: 180.419,
    y2: 26.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1065_1234",
    x1: 180.427,
    y1: 76.2593,
    x2: 180.427,
    y2: 103.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1065_1234",
    x1: 218.513,
    y1: 38,
    x2: 218.513,
    y2: 64.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1065_1234",
    x1: 218.513,
    y1: 0,
    x2: 218.513,
    y2: 26.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1065_1234",
    x1: 218.513,
    y1: 76.2593,
    x2: 218.513,
    y2: 103.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1065_1234",
    x1: 256.466,
    y1: 38,
    x2: 256.466,
    y2: 64.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1065_1234",
    x1: 256.466,
    y1: 0,
    x2: 256.466,
    y2: 26.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1065_1234",
    x1: 256.474,
    y1: 76.2593,
    x2: 256.474,
    y2: 103.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1065_1234",
    x1: 294.419,
    y1: 38,
    x2: 294.419,
    y2: 64.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1065_1234",
    x1: 294.419,
    y1: 0,
    x2: 294.419,
    y2: 26.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1065_1234",
    x1: 294.427,
    y1: 76.2593,
    x2: 294.427,
    y2: 103.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1065_1234",
    x1: 240.841,
    y1: 24.0001,
    x2: 240.841,
    y2: 89.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1209,
    stopColor: "#F6BA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2698,
    stopColor: "#F7C676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4266,
    stopColor: "#F8CF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5926,
    stopColor: "#F9D69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7741,
    stopColor: "#FADAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FADBAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1065_1234",
    x1: 243.298,
    y1: 55.1481,
    x2: 243.298,
    y2: 79.5231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4AE39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#F5B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2782,
    stopColor: "#F6BB5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4872,
    stopColor: "#F6C16E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7156,
    stopColor: "#F7C578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C67B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1065_1234",
    x1: 213,
    y1: 56.5,
    x2: 278,
    y2: 56.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#99BAED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F81D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1065_1234",
    x1: 212.992,
    y1: 56.5005,
    x2: 277.992,
    y2: 56.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6798E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E76D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1065_1234",
    x1: 250.164,
    y1: 56.4999,
    x2: 267.912,
    y2: 56.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCDDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1065_1234",
    x1: 233.892,
    y1: 24.0001,
    x2: 233.892,
    y2: 89.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2259,
    stopColor: "#FADAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4074,
    stopColor: "#F9D69F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5734,
    stopColor: "#F8CF8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    stopColor: "#F7C676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8791,
    stopColor: "#F6BA58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4AE39"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBg);
export default __webpack_public_path__ + "static/media/medal_bg.4e8002f8367e5e7853d74aade184a53e.svg";
export { ForwardRef as ReactComponent };